/**
 * [XPHUB] Colour variant selector.
 * snippets/xphub-color-picker.liquid renders the label and the current product's
 * tile server-side (final height on first paint, no layout shift). This script
 * fetches the sibling products sharing the same XPHUB_FSKU tag from
 * /collections/all/<tag>?view=xphub-color-picker and swaps the list, cloning the
 * server-rendered <li> as template. On failure the current tile stays.
 * A custom element so it also initialises inside the quickview modal and after
 * theme-editor re-renders, without any event plumbing.
 */
(function () {
  'use strict';

  if (customElements.get('xphub-color-picker')) return;

  class XPHubColorPicker extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';

      var fsku = this.dataset.fsku;
      if (!fsku) return;

      var url = window.routes.rootUrlWithoutSlash + '/collections/all/' + encodeURIComponent(fsku) + '?view=xphub-color-picker';
      var self = this;

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.json();
        })
        .then(function (data) {
          var products = (data && data.products) || [];
          if (products.length) self.render(products);
        })
        .catch(function (err) {
          console.error('XPHub color picker: failed to load siblings', err);
        });
    }

    render(products) {
      var list = this.querySelector('.XPHub__ColorPickerList');
      var template = list && list.querySelector('.XPHub__ColorPickerItem');
      if (!template) return;

      var currentHandle = this.dataset.handle;
      var fragment = document.createDocumentFragment();

      products.forEach(function (p) {
        var item = template.cloneNode(true);
        var link = item.querySelector('.XPHub__ColorPickerLink');
        var thumb = item.querySelector('.XPHub__ColorPickerThumb');
        var name = p.color || p.title;
        var active = p.handle === currentHandle;

        link.href = p.url;
        link.classList.toggle('Active', active);
        if (active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');

        // CSS background, not <img>: keeps the Swym PDP button heuristic (largest visible <img>) off the picker.
        thumb.style.backgroundImage = p.thumbnail ? 'url("' + String(p.thumbnail).replace(/"/g, '%22') + '")' : '';

        item.querySelector('.XPHub__ColorPickerName').textContent = name;
        fragment.appendChild(item);
      });

      list.replaceChildren(fragment);
    }
  }

  customElements.define('xphub-color-picker', XPHubColorPicker);
})();
